module.exports = __webpack_public_path__ + "static/media/Farma Pasa - Pustoparan - 16 Farma Pasa - Kultura memoara.1288128a.mp3";